var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 15,
    viewBox: "0 0 47 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.273 0.660645H40.4063C39.5397 0.660645 38.873 0.927311 38.473 1.79398L33.0063 14.2606H36.873C36.873 14.2606 37.5397 12.594 37.673 12.194C38.073 12.194 41.873 12.194 42.4063 12.194C42.5397 12.6606 42.873 14.194 42.873 14.194H46.3397L43.273 0.660645ZM38.7397 9.39398C39.073 8.59398 40.2063 5.59398 40.2063 5.59398C40.2063 5.66064 40.5397 4.79398 40.673 4.32731L40.9397 5.52731C40.9397 5.52731 41.673 8.79398 41.8063 9.46064H38.7397V9.39398Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2729 9.79403C33.2729 12.594 30.7395 14.4607 26.8062 14.4607C25.1395 14.4607 23.5395 14.1274 22.6729 13.7274L23.2062 10.6607L23.6729 10.8607C24.8729 11.394 25.6728 11.594 27.1395 11.594C28.2062 11.594 29.3395 11.194 29.3395 10.2607C29.3395 9.66069 28.8729 9.26069 27.4062 8.59403C26.0062 7.92736 24.1395 6.86069 24.1395 4.92736C24.1395 2.26069 26.7395 0.460693 30.4062 0.460693C31.8062 0.460693 33.0062 0.72736 33.7395 1.06069L33.2062 3.99403L32.9395 3.72736C32.2729 3.46069 31.4062 3.19403 30.1395 3.19403C28.7395 3.26069 28.0729 3.86069 28.0729 4.39403C28.0729 4.99403 28.8729 5.46069 30.1395 6.06069C32.2729 7.06069 33.2729 8.19403 33.2729 9.79403Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.739502 0.79401L0.806169 0.527344H6.5395C7.3395 0.527344 7.9395 0.79401 8.1395 1.66068L9.40617 7.66068C8.1395 4.46068 5.20617 1.86068 0.739502 0.79401Z",
    fill: "#F9B50B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4727 0.660661L11.6727 14.194H7.73934L4.40601 2.86066C6.80601 4.39399 8.80601 6.79399 9.53934 8.46066L9.93934 9.86066L13.5393 0.593994H17.4727V0.660661Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0059 0.593994H22.6726L20.3393 14.194H16.6726L19.0059 0.593994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.3c90e548.svg";
export { ForwardRef as ReactComponent };